import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

interface State {
  fbclid: string | null;
  fbp: string | null;
  setAnalyticsTokens: ({
    fbclid,
    fbp
  }: {
    fbclid: string;
    fbp: string;
  }) => void;
}

const useFacebookAnalyticsStore = create<State>((set) => ({
  setAnalyticsTokens: async ({ fbclid, fbp }) => {
    set({ fbclid, fbp });
  },
  fbclid: null,
  fbp: null
}));

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('FacebookAnalyticsStore', useFacebookAnalyticsStore);
}

export default useFacebookAnalyticsStore;
